export default "__VITE_PUBLIC_ASSET__346b9eab__"